'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putSavedTenants = exports.getSavedTenants = undefined;

var _serviceHelpers = require('./serviceHelpers');

var _lodash = require('lodash.filter');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSavedTenants = exports.getSavedTenants = function getSavedTenants(accessToken, env) {
  return (0, _serviceHelpers.callFetch)('customizrUrl', 'GET', 'v1/resources/' + (env === 'int' ? 'int-' : '') + 'platform-selected-tenant/settings', null, accessToken, env).catch(function (err) {
    if (err.response && err.response.status === 404) {
      //not actually an issue, just means this user hasn't saved it yet
      return {};
    }
    // if customizr fails, there is no real harm in starting over and having the user re-select their tenant
    console.warn(err);
    return {};
  });
};

var putSavedTenants = exports.putSavedTenants = function putSavedTenants(accessToken, env, tenants) {
  return (0, _serviceHelpers.callFetch)('customizrUrl', 'PUT', 'v1/resources/' + (env === 'int' ? 'int-' : '') + 'platform-selected-tenant/settings', JSON.stringify(tenants), accessToken, env).catch(function (err) {
    // if customizr fails, there isn't much we can do other than log it.  They will not have their tenants persisted.
    console.warn(err);
  });
};
//# sourceMappingURL=customizr.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/services/customizr.js
// module id = 569
// module chunks = 0